// extracted by mini-css-extract-plugin
module.exports = {"Impressum":"Impressum-module--Impressum--vHQ_f","Impressum__Copy":"Impressum-module--Impressum__Copy--1GT_9"};